import { Box, Typography } from "@mui/material";
import GrassIcon from "@mui/icons-material/Grass";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';

const HomeFeatures = () => {
  return (
    <>
      <Box>
        <Box
          sx={{
            textAlign: "center",
            py: { xs: 4, sm: 6, md: 8 },
            px: { xs: 2, sm: 4 },
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontSize: { xs: "1.2rem", sm: "2rem", md: "2rem" },
              color: "rgb(15 23 42)",
              fontWeight: 600,
              mb: 2,
            }}
          >
            Fresh, Clean, and Locally Grown
          </Typography>
          <Typography
            sx={{
              color: "#666",
              fontSize: { xs: "1rem", sm: "1.125rem" }, // responsive body text
              maxWidth: 700,
              mx: "auto",
            }}
          >
            We deliver yams to homes, restaurants, and stores across Nigeria,
            harvested fresh and priced fairly.
          </Typography>
        </Box>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "repeat(1, 1fr)",
              sm: "repeat(2, 1fr)",
              md: "repeat(3, 1fr)",
            },
            gap: 2,
            px: { xs: 2, sm: 4, md: 12 },
          }}
        >
          {/* Feature 1 */}

          <Box sx={{ border: "1px solid #D1D5DB", borderRadius: 2, p: 3 }}>
            {/* logo */}
            <Box
              sx={{
                backgroundColor: "#F0F4EA",
                p: 1.5,
                borderRadius: 2,
                display: "inline-flex",
                justifyContent: "center",
                alignItems: "center",
                mb: 1,
              }}
            >
              <GrassIcon sx={{ fontSize: "1.5rem", color: "#6B7A54" }} />
            </Box>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
              Buy Yam
            </Typography>
            <Typography sx={{ color: "#666", mb: 2 }}>
              premium quality at market-friendly prices.
            </Typography>
          </Box>

          {/* Feature 2 */}
          <Box sx={{ border: "1px solid #D1D5DB", borderRadius: 2, p: 3 }}>
            {/* logo */}
            <Box
              sx={{
                backgroundColor: "#F0F4EA",
                p: 1.5,
                borderRadius: 2,
                display: "inline-flex",
                justifyContent: "center",
                alignItems: "center",
                mb: 1,
              }}
            >
              <ShoppingCartOutlinedIcon
                sx={{ fontSize: "1.5rem", color: "#6B7A54" }}
              />
            </Box>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
              Bulk Supply
            </Typography>
            <Typography sx={{ color: "#666", mb: 2 }}>
              Reliable delivery for restaurants, retailers, and vendors.
            </Typography>
          </Box>

          {/* Feature 3 */}
          <Box sx={{ border: "1px solid #D1D5DB", borderRadius: 2, p: 3 }}>
            {/* logo */}
            <Box
              sx={{
                backgroundColor: "#F0F4EA",
                p: 1.5,
                borderRadius: 2,
                display: "inline-flex",
                justifyContent: "center",
                alignItems: "center",
                mb: 1,
              }}
            >
              <LocalShippingOutlinedIcon
                sx={{ fontSize: "1.5rem", color: "#6B7A54" }}
              />
            </Box>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
              Fast Local Delivery
            </Typography>
            <Typography sx={{ color: "#666", mb: 2 }}>
              clean, ready-to-cook yams delivered fresh.
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default HomeFeatures;
